"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.async-iterator.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.symbol.to-string-tag.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.json.to-string-tag.js");
require("core-js/modules/es.math.to-string-tag.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.get-prototype-of.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.proto.js");
require("core-js/modules/es.object.set-prototype-of.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkWAFErrors = checkWAFErrors;
exports.getDetailedMessage = getDetailedMessage;
exports.loginFailure = loginFailure;
exports.loginRequest = loginRequest;
exports.loginSuccess = loginSuccess;
exports.logout = logout;
exports.send2FAResendActionRequest = send2FAResendActionRequest;
exports.send2FAResendRequest = send2FAResendRequest;
exports.send2FAVerifyActionRequest = send2FAVerifyActionRequest;
exports.send2FAVerifyRequest = send2FAVerifyRequest;
exports.sendAppleLoginRequest = sendAppleLoginRequest;
exports.sendFacebookLoginRequest = sendFacebookLoginRequest;
exports.sendLoginRequest = sendLoginRequest;
exports.sendResetPassword = sendResetPassword;
exports.sendSignOutRequest = sendSignOutRequest;
exports.sendSignupRequest = sendSignupRequest;
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.object.assign.js");
var ActionType = _interopRequireWildcard(require("./authActionTypes"));
var _api = _interopRequireDefault(require("../../http/api"));
var _googleTagManager = require("../../tracking/googleTagManager");
var _storage = require("../../util/storage");
var _statusCodes = _interopRequireDefault(require("../../http/statusCodes"));
var _detectBusinessUnit = _interopRequireDefault(require("../../util/detectBusinessUnit"));
var _userActions = require("../user/userActions");
var _experiments = require("../../experiments");
var _trackingHelper = require("../../tracking/trackingHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// checks the reason from backend, and retuns a more specific error message
// or if reason doesn't exist, sends the message that comes from backend, or default error message

/**
 * An constant that stores error message and type in key value pair
 */
var ERROR_MESSAGE = {
  invalid_password: 'Your email and password do not match.',
  invalid_email: 'You have entered an invalid email.',
  user_locked: 'Looks like you have forgotten your password. Please click the forgot password link above to reset your password and continue.',
  'facebook-missing-email': 'You must provide Zola access to your Facebook email address to create your account.',
  default: 'There was a problem processing your request. Please try again or contact customer support for assistance.'
};

/**
 * Construct an error message base on error message types. If no match for the error type, return default.
 */
function getDetailedMessage(error) {
  var errorMessage = error && error.category && ERROR_MESSAGE[error.category.reason];
  return errorMessage || ERROR_MESSAGE.default;
}

/**
 * Construct an error message that contains the error response and user friendly message
 */
function createError(error) {
  var errorData = Object.assign({
    detailedMessage: getDetailedMessage(error === null || error === void 0 ? void 0 : error.response)
  }, error);
  throw errorData;
}

/**
 * Construct an error object if the status is a error, otherwise return the same response
 */
function checkWAFErrors(response) {
  if (response.status === _statusCodes.default.FORBIDDEN) {
    var error = new Error(response.statusText);
    error.response = response;
    error.detailedMessage = 'Please contact support@zola.com and we will assist you.';
    throw error;
  }
  if (response.status === _statusCodes.default.NOT_ACCEPTABLE) {
    var _error = new Error(response.statusText);
    _error.response = response;
    _error.detailedMessage = 'Your account has been locked due to too many failed login attempts. Please wait 1 hour and try again.';
    throw _error;
  }
  if (response.status === _statusCodes.default.TOO_MANY_REQUESTS) {
    var _error2 = new Error(response.statusText);
    _error2.response = response;
    _error2.detailedMessage = 'Please wait a few moments ...';
    throw _error2;
  }
}

/**
 * Action Creator: dispatch LOGIN_SUCCESS event
 */
function loginSuccess(email) {
  return {
    type: ActionType.LOGIN_SUCCESS,
    payload: {
      email: email
    }
  };
}

/**
 * Action Creator: dispatch LOGIN_FAILURE event
 */
function loginFailure(error) {
  var _error$response, _error$response2;
  return {
    type: ActionType.LOGIN_FAILURE,
    payload: {
      status: (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status,
      statusText: (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.statusText
    }
  };
}

/**
 * Action Creator: dispatch LOGIN_REQUEST event
 */
function loginRequest() {
  return {
    type: ActionType.LOGIN_REQUEST
  };
}

/**
 * Action Creator: dispatch LOGOUT event
 */
function logout() {
  return {
    type: ActionType.LOGOUT
  };
}

/**
 * Result of a succesful login.
 */

/**
 * Request body to login a couple using an email and password and optional invitation_session_id
 */

/**
 * Send login request to the server (web-nav) then notify GTM the user is logged in.
 *
 * @param loginFormRequest - Login Parameters
 * @returns A promise, when resolved, will have the user logged in.
 */
function sendLoginRequest(loginFormRequest) {
  return _api.default.post('/website-nav/web-api/v1/auth/login', loginFormRequest).then(function (data) {
    (0, _googleTagManager.setGTMLoggedIn)();
    (0, _experiments.clearExperimentStorage)();
    return data;
  }).then(function (data) {
    return (0, _userActions.identifyUserSailthru)(loginFormRequest.email).then(function () {
      return data;
    });
  }).catch(function (error) {
    checkWAFErrors(error);
    createError(error);
  });
}
/**
 * Send signup request to the server. Notify GTM the user is logged in
 */
function sendSignupRequest(createUserRequest) {
  var businessUnit = (0, _detectBusinessUnit.default)();
  var finalRequest = _objectSpread(_objectSpread({}, createUserRequest), {}, {
    business_unit_source: businessUnit
  });
  return _api.default.post('/website-nav/web-api/v1/user/create', finalRequest).then( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
      var freshUserContext, cookie;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            (0, _googleTagManager.setGTMLoggedIn)();
            _context.next = 3;
            return (0, _userActions.fetchUserContext)();
          case 3:
            freshUserContext = _context.sent;
            (0, _userActions.identifyUser)({
              userContext: freshUserContext,
              hasIdentified: false
            });
            (0, _storage.setAllStorage)('zolaUserCreatedAt', new Date().toISOString());
            (0, _googleTagManager.setGTMLoggedIn)();
            cookie = (0, _storage.getCookie)('pkey');
            if (cookie === '') {
              cookie = null;
            }
            (0, _trackingHelper.trackUserCreated)(freshUserContext.email, cookie);
            (0, _userActions.identifyUserSailthru)(freshUserContext.email).catch(function () {
              return undefined;
            });
            return _context.abrupt("return", data);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }()).catch(function (error) {
    return createError(error);
  });
}

/**
 * Send logout request to the server. Notify GTM the user is logged out
 */
function sendSignOutRequest() {
  return _api.default.get('/website-nav/web-api/v1/auth/signout').then(function () {
    (0, _googleTagManager.setGTMLoggedOut)();
  }).catch(function (error) {
    return createError(error);
  });
}

/**
 * Send reset password request to reset user password.
 *
 * @returns reset password callback
 */
function sendResetPassword(email) {
  var createResetPasswordRequest = {
    email: email,
    expires_in_num_days: 1,
    send_email: true,
    business_unit: (0, _detectBusinessUnit.default)()
  };
  return _api.default.post('/website-nav/web-api/v1/user/reset_password', createResetPasswordRequest);
}
function sendFacebookLoginRequest(fbLoginRequest) {
  return _api.default.post('/website-nav/web-api/v1/auth/facebook-login', fbLoginRequest);
}
function sendAppleLoginRequest(appleLoginRequest) {
  return _api.default.post('/website-nav/web-api/v1/auth/apple-login', appleLoginRequest);
}
function send2FAResendRequest(resendCodeRequest) {
  return _api.default.post('/website-nav/web-api/v1/twoFA/resend', resendCodeRequest);
}
function send2FAVerifyRequest(verifyRequest) {
  return _api.default.post('/website-nav/web-api/v1/twoFA/verify', verifyRequest).catch(function (error) {
    return createError(error);
  });
}
function send2FAVerifyActionRequest(verifyRequest) {
  return _api.default.post('/website-nav/web-api/v1/twoFA/action/verify', verifyRequest).catch(function (error) {
    return createError(error);
  });
}
function send2FAResendActionRequest() {
  return _api.default.post('/website-nav/web-api/v1/twoFA/action/resend');
}